import actionTypes from '../constants/action-types';
import globals from '../../globals';
import DEFAULT_OPTIONS from '../constants/default-options';

const setElementAttribute = (elementId, attr, value, options = DEFAULT_OPTIONS) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.SET_ELEMENT_ATTRIBUTE,
    payload: {
      elementId,
      attr,
      value,
      options,
    },
  });

export default setElementAttribute;
